import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { DesignNote } from '../components/DesignNote';
import { post } from '../data/blog';
export function BlogPost() {
  return <main id="main" className="bg-paper" data-id="element-610" data-mp="3pdls8i6dzcdk">
      <div className="mx-auto max-w-shell px-6 pb-12 pt-8 lg:px-10" data-id="element-611" data-mp="3pcalqalk3qir">
        <nav aria-label="Breadcrumb" data-id="element-612" data-mp="3kf0z12pjxsym">
          <ol className="flex flex-wrap items-center gap-2 text-[12.5px] text-muted" data-id="element-613" data-mp="3fgg0r8tv1jct">
            <li data-id="element-614" data-mp="3fe38a1qh7qli">
              <Link to="/" className="hover:text-ink hover:underline" data-id="element-615" data-mp="3ahmjr6fd7a7w">
                Home
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-616" data-mp="36gsvud1x9vf0" />
            <li data-id="element-617" data-mp="31gy5qbpz19v0">
              <Link to="/blog" className="hover:text-ink hover:underline" data-id="element-618" data-mp="31hgcw3e698hp">
                Blog
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-619" data-mp="14nmwr86j2vru" />
            <li aria-current="page" className="text-ink" data-id="element-620" data-mp="zqczj6cwdftg">
              {post.category}
            </li>
          </ol>
        </nav>
      </div>

      <header className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-621" data-mp="117ex51qikyhw">
        <div className="max-w-3xl" data-id="element-622" data-mp="164y91uzqoz6o">
          <p className="label text-olive" data-id="element-623" data-mp="161slik6re5d2">{post.category}</p>
          <h1 className="mt-6 font-display text-[46px] font-300 leading-[0.99] text-ink sm:text-[62px]" data-id="element-624" data-mp="s5p5buspzxjl">
            {post.title}
          </h1>
          <p className="mt-7 max-w-prose text-[18px] font-300 leading-[1.7] text-ink/75" data-id="element-625" data-mp="1kt1hrc562oz6">
            {post.deck}
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2 text-[13px] text-muted" data-id="element-626" data-mp="1ov6bsbzj1nmc">
            <span className="text-ink" data-id="element-627" data-mp="1b41gtn73tjic">By {post.author}</span>
            <span aria-hidden="true" data-id="element-628" data-mp="1b1f8vmgax1zl">·</span>
            <span data-id="element-629" data-mp="1g1b2qsvabd1f">{post.published}</span>
            <span aria-hidden="true" data-id="element-630" data-mp="1g08dsqhivko5">·</span>
            <span className="text-olive" data-id="element-631" data-mp="23rdv7a342l0k">{post.updated}</span>
            <span aria-hidden="true" data-id="element-632" data-mp="23q2ob1edcx58">·</span>
            <span data-id="element-633" data-mp="28ivrhku6vxf7">{post.readMinutes} min read</span>
          </div>
        </div>

        <img src={post.image} alt={post.imageAlt} className="photo-soft mt-14 aspect-[3/2] w-full object-cover" data-id="element-634" data-mp="2ieckozier5cn" />
      </header>

      <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-635" data-mp="2ddgci9r0wx1f">
        <article className="max-w-prose" data-id="element-636" data-mp="28evcaabrudcz">
          <p className="text-[19px] font-300 leading-[1.8] text-ink/85" data-id="element-637" data-mp="23hdd3bnk3ci6">
            {post.intro}
          </p>

          {post.sections.map(section => <section key={section.heading} className="mt-14" data-id="element-638" data-mp="1zhb9gwy9g909">
              <h2 className="font-display text-[32px] font-300 leading-tight text-ink" data-id="element-639" data-mp="1uorx23bb7jx1">
                {section.heading}
              </h2>
              <p className="mt-5 text-[17px] leading-[1.9] text-ink/80" data-id="element-640" data-mp="1pq8ac0ow643m">
                {section.body}
              </p>
            </section>)}

          <section className="mt-16" data-id="element-641" data-mp="1fsap7m2bwnf8">
            <h2 className="font-display text-[32px] font-300 leading-tight text-ink" data-id="element-642" data-mp="1fr974xmwb0o0">
              Every lighting this year
            </h2>
            <ul className="mt-8 border-t border-line" data-id="element-643" data-mp="3ndsw5ftzt9yf">
              {post.lightings.map(l => <li key={l.name} className="border-b border-line py-7" data-id="element-644" data-mp="3reunlaho4hpu">
                  <div className="flex flex-wrap items-baseline justify-between gap-x-6 gap-y-1" data-id="element-645" data-mp="3rh7am22a9i9r">
                    <h3 className="font-display text-[25px] font-400 leading-snug text-ink" data-id="element-646" data-mp="6qm4gsn1syy">
                      {l.name}
                    </h3>
                    <p className="label text-olive" data-id="element-647" data-mp="33qbguze9oczv">
                      {l.date} · {l.time}
                    </p>
                  </div>
                  <p className="mt-1.5 text-[13.5px] text-muted" data-id="element-648" data-mp="38mjzimroaobs">{l.place}</p>
                  <p className="mt-3 text-[15.5px] leading-[1.8] text-ink/75" data-id="element-649" data-mp="3dm4z8zeo30pk">
                    {l.note}
                  </p>
                </li>)}
            </ul>
          </section>

          <div className="mt-16" data-id="element-650" data-mp="2kyiwftd9k03r">
            <DesignNote label="The linking rule" note="Every seasonal post ends by handing the reader to an evergreen hub. This is what turns a December spike into a return visit in March." data-id="element-651" data-mp="2kx7pxlsfoe8y" />
            <aside className="bg-foam/45 px-8 py-9" data-id="element-652" data-mp="rh4iw0n5i889">
              <p className="label text-ink/60" data-id="element-653" data-mp="re8migqybrlx">Keep going</p>
              <h2 className="mt-4 font-display text-[28px] font-300 leading-tight text-ink" data-id="element-654" data-mp="158ro4pz2mr36">
                Looking for what’s on next weekend?
              </h2>
              <p className="mt-3 text-[15px] leading-[1.8] text-ink/75" data-id="element-655" data-mp="1f5nryie0yp1e">
                The full family events calendar is updated every Thursday, and
                the winter break guide has fourteen more ideas for the days
                between the holidays.
              </p>
              <div className="mt-7 flex flex-wrap gap-4" data-id="element-656" data-mp="1o480wrts9kcf">
                <Link to="/events" className="label border border-ink/30 px-7 py-3.5 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-657" data-mp="1j8som4bfbwi4">
                  Family events calendar
                </Link>
                <Link to="/things-to-do" className="label border border-ink/30 px-7 py-3.5 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-658" data-mp="20hv26dhqt81e">
                  Things to do
                </Link>
              </div>
            </aside>
          </div>

          <p className="mt-12 border-t border-line pt-8 text-[13px] leading-[1.8] text-muted" data-id="element-659" data-mp="1voa8uyr3h28j">
            Dates confirmed with each organizer in November. Times occasionally
            shift — check the official listing before you drive over.
          </p>
        </article>
      </div>

      <section aria-labelledby="next-h" className="border-t border-line bg-white" data-id="element-660" data-mp="18r8i18843oni">
        <div className="mx-auto max-w-shell px-6 py-20 lg:px-10" data-id="element-661" data-mp="1cs0ojtplnfg3">
          <h2 id="next-h" className="label text-muted" data-id="element-662" data-mp="3335bf6q474l7">
            More from the blog
          </h2>
          <ul className="mt-10 grid gap-x-14 gap-y-10 sm:grid-cols-2" data-id="element-663" data-mp="375s5zfe673m3">
            {post.relatedPosts.map(related => <li key={related.title} className="group relative border-b border-line pb-7" data-id="element-664" data-mp="jxvxmrrsbcnu">
                <p className="label text-olive" data-id="element-665" data-mp="ewomciqfnvcf">{related.category}</p>
                <h3 className="mt-3 font-display text-[27px] font-300 leading-tight text-ink" data-id="element-666" data-mp="avux9m198ahy">
                  <Link to="/blog" className="decoration-olive decoration-1 underline-offset-[7px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-667" data-mp="5xbaxkir0wp2">
                    {related.title}
                  </Link>
                </h3>
              </li>)}
          </ul>
        </div>
      </section>
    </main>;
}